module.exports = __webpack_public_path__ + "static/img/shouhou.b7907d6.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shouhou.png
// module id = 188
// module chunks = 1